import './Title.css';
import { useEffect, useRef } from 'react';

export default function Title({ text, size, color, fontWeight="600", lineHeight, level="h2", textAlign }) {
  const idRef = useRef(`title-${Math.random().toString(36).slice(2, 11)}`);
  const HeadingTag = level;
  let responsive = false;

  if (Array.isArray(size) && size.length > 1) {
    responsive = true;
  }

  useEffect(() => {
    if (!responsive) return;
    const [big, medium, small] = size;
    const styleTag = document.createElement('style');
    styleTag.id = idRef.current;
    styleTag.innerHTML = `
      .${idRef.current} { font-size: ${big}; }
      @media (max-width: 900px) {
        .${idRef.current} { font-size: ${medium || big}; }
      }
      @media (max-width: 600px) {
        .${idRef.current} { font-size: ${small || medium || big}; }
      }
    `;
    document.head.appendChild(styleTag);
    return () => {
      const el = document.getElementById(idRef.current);
      if (el) el.remove();
    };
  }, [size, responsive]);

  const style = {
    ...(!responsive && size && { fontSize: size }),
    ...(color && { color }),
    ...(fontWeight && { fontWeight }),
    ...(lineHeight && { lineHeight }),
    ...(textAlign && { textAlign }),
  };

  return (
    <HeadingTag className={`${responsive ? idRef.current : ''}`} style={style}>
      {text}
    </HeadingTag>
  );
}